import React, { useEffect, useState } from "react";
import styles from "./userMgmt.module.css";
import AddUserModal from "./AddUserModal";
import UserNotification from "../components/Notification/UserNotifiaction/UserNotification";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TablePagination,
} from "@mui/material";
import { useAllProduct } from "../api-context/commonApiContext";
import config from "../service/config";
import FullScreenLoader from "../reusable/loader/FullScreenLoader";

const UserMgmt = () => {
  const { role, userMail, clientCompany, clientId, loading, setLoading } =
    useAllProduct();
  const [currentPage, setCurrentPage] = useState(0);
  const [removeUserModel, setRemoveUserModel] = useState(false);
  const [reasonModel, setReasonModel] = useState(false);
  const [itemsPerPage, setItemsPerPage] = useState(8);
  const [showModal, setShowModal] = useState(false);
  const [selectedRowVal, setSelectedRowVal] = useState({});
  const [userAdded, setUserAdded] = useState(false);
  const [users, setUsers] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [assignTo, setAssignTo] = useState("");
  const [errors, setErrors] = useState({});
  const [userByRole, setUserByRole] = useState([]);
  const [reason, setReason] = useState("");
  const [reloadButton, setReloadButton] = useState(false);

  useEffect(() => {
    // console.log("clinet--->", clientCompany.length);

    if (
      clientCompany &&
      clientCompany.trim() !== "" &&
      clientCompany !== "undefined"
    ) {
      setLoading(true);
      fetch(
        `${
          config.node_api_endpoint
        }/api/company-users?client_id=${clientId}&company_name=${encodeURIComponent(
          clientCompany
        )}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY, // ✅ your API key here
          },
        }
      )
        .then((res) => res.json())
        .then((data) => {
          setLoading(false);
          setReloadButton(false);
          console.log("data-->", data);

          setUsers(data.data);
          console.log("Fetched users:", data);
        })
        .catch((err) => {
          setLoading(false);
          console.error("Error fetching users:", err);
        });
    } else {
      setLoading(true);
      fetch(`${config.node_api_endpoint}/api/users`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "x-api-key": process.env.REACT_APP_API_KEY, // ✅ your API key here
        },
      })
        .then((res) => res.json())
        .then((data) => {
          setLoading(false);
          setReloadButton(false);
          setUsers(data.data);
        })
        .catch((err) => {
          setLoading(false);
          console.error("Error fetching users:", err);
        });
    }
  }, [showModal, reloadButton]);

  useEffect(() => {
    if (Object.keys(selectedRowVal).length > 0) {
      const filterUsers = users?.filter(
        (data) =>
          selectedRowVal?.auth[0]?.role?.toString() ===
          data?.auth[0]?.role?.toString()
      );
      console.log("user", filterUsers);
      setUserByRole(
        filterUsers.filter(
          (data) =>
            data.status === "Active" && data.mailId !== selectedRowVal.mailId
        )
      );
    }
  }, [selectedRowVal]);

  const handlePaginationChange = (page, rowsPerPage) => {
    setCurrentPage(page);
    setItemsPerPage(rowsPerPage);
  };

  const filteredUsers = users?.filter(
    (user) =>
      user.userName?.toLowerCase()?.includes(searchText) ||
      user.mailId?.toLowerCase()?.includes(searchText) ||
      user.phNumber?.includes(searchText)
  );

  const paginatedReports = filteredUsers.slice(
    currentPage * itemsPerPage,
    currentPage * itemsPerPage + itemsPerPage
  );

  const deleteUserData = async (id, userName, mailId, reason, assignTo) => {
    try {
      const res = await fetch(
        `${config.node_api_endpoint}/api/users/${id}/remove`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            "x-api-key": process.env.REACT_APP_API_KEY,
          },
          body: JSON.stringify({
            reason,
            assignTo,
            client_id: clientId,
            company_name: clientCompany,
          }),
        }
      );

      if (!res.ok) throw new Error("Failed to remove user");

      const result = await res.json();
      console.log(result.message);

      // Update user list locally
      setUsers((prev) =>
        prev.map((u) =>
          u.id === id
            ? {
                ...u,
                status: "Removed",
                removalReason: reason,
                assignTo: assignTo,
              }
            : u
        )
      );
      setRemoveUserModel(false);
    } catch (err) {
      console.error("Error marking user as removed:", err);
      alert("Failed to update user status.");
    }
  };

  console.log("userByRole", userByRole);

  return (
    <>
      <FullScreenLoader spinning={loading} />
      {userAdded && <UserNotification setUserAdded={setUserAdded} />}
      <div className="d-flex justify-content-between">
        {reasonModel && (
          <div
            className={`modal show d-block ${styles.rejectionModal}`}
            tabIndex="-1"
            role="dialog"
          >
            <div
              className={`modal-dialog modal-dialog-centered ${styles.modalDialog}`}
              role="document"
            >
              <div className={`modal-content ${styles.modalContent}`}>
                <div
                  className={`modal-header ${styles.modalHeader} d-flex justify-content-center`}
                >
                  <h5 className={`modal-title ${styles.modalTitle}`}>
                    User Removed
                  </h5>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={() => setReasonModel(false)}
                  />
                </div>
                <div
                  className={`modal-body ${styles.modalBody} d-flex justify-content-center align-items-center`}
                >
                  <span style={{ fontWeight: "600", fontSize: "16px" }}>
                    {"Reason for removal: "}
                  </span>
                  <span className="px-2">{selectedRowVal?.removalReason}</span>
                </div>
                <div
                  className={`modal-body ${styles.modalBody} d-flex justify-content-center align-items-center`}
                >
                  <span style={{ fontWeight: "600", fontSize: "16px" }}>
                    {"Assigned To: "}
                  </span>
                  <span className="px-2">
                    {selectedRowVal?.assignTo?.email || ""}
                  </span>
                </div>
              </div>
            </div>
          </div>
        )}
        {removeUserModel && (
          <div
            className={`modal show d-block ${styles.rejectionModal}`}
            tabIndex="-1"
            role="dialog"
          >
            <div
              className={`modal-dialog modal-dialog-centered ${styles.modalDialog}`}
              role="document"
            >
              {userByRole?.length > 0 ? (
                <div className={`modal-content ${styles.modalContent}`}>
                  <div className={`modal-header ${styles.modalHeader}`}>
                    <h5 className={`modal-title ${styles.modalTitle}`}>
                      Are you sure you want to remove the user?
                    </h5>
                  </div>
                  <div className={`modal-body ${styles.modalBody}`}>
                    <FormControl className="w-100 mb-2">
                      <InputLabel id="escrow-select-label">
                        Assign To
                      </InputLabel>
                      <Select
                        labelId="escrow-select-label"
                        id="escrow-select"
                        value={JSON.stringify(assignTo)} // Convert object to string
                        label="Assign To"
                        onChange={(e) =>
                          setAssignTo(JSON.parse(e.target.value))
                        } // Parse string back to object
                        sx={{ borderRadius: "12px" }}
                      >
                        {userByRole.map((p, idx) => (
                          <MenuItem
                            key={idx}
                            value={JSON.stringify({
                              email: p.mailId,
                              name: p.userName,
                            })}
                          >
                            {p.userName} ({p.mailId}){" "}
                            {/* Show both name and email */}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    {errors.assignTo && (
                      <div className={styles.errorMessage}>
                        {errors.assignTo}
                      </div>
                    )}

                    <textarea
                      className={`${styles.textarea}`}
                      placeholder="Write reason for rejection..."
                      value={reason}
                      onChange={(e) => setReason(e.target.value)}
                    />
                    {errors.reason && (
                      <div className={styles.errorMessage}>{errors.reason}</div>
                    )}
                  </div>
                  <div className={`modal-footer ${styles.modalFooter}`}>
                    <div
                      className={`${styles.cancelButton}  d-flex justify-content-center align-items-center`}
                      onClick={() => {
                        setErrors("");
                        setAssignTo("");
                        setReason("");
                        setRemoveUserModel(false);
                      }}
                    >
                      <button
                        type="button"
                        className={`btn`}
                        style={{ color: "#2348AB" }}
                      >
                        No
                      </button>
                    </div>
                    <div
                      className={`${styles.rejectButton}  d-flex justify-content-center align-items-center`}
                      onClick={() =>
                        deleteUserData(
                          selectedRowVal.id,
                          selectedRowVal.userName,
                          selectedRowVal.mailId,
                          reason,
                          assignTo
                        )
                      }
                    >
                      <button
                        type="button"
                        className={`btn`}
                        style={{ color: "#ffffff" }}
                      >
                        Yes
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <div className={`modal-content ${styles.modalContent}`}>
                  <div className={`modal-header ${styles.modalHeader}`}></div>
                  <div className={`modal-body ${styles.modalBody}`}>
                    <h5
                      className={`modal-title ${styles.modalTitle} d-flex justify-content-center`}
                      style={{ color: "#DC3545" }}
                    >
                      Unable to delete this user.
                    </h5>
                    <h5
                      className={`modal-title ${styles.modalTitle} d-flex justify-content-center`}
                      style={{ color: "#DC3545" }}
                    >
                      No other {selectedRowVal.auth[0].role.toString()}{" "}
                      available to reassign.
                    </h5>
                  </div>
                  <div className={`modal-footer ${styles.modalFooter}`}>
                    <div
                      className={`${styles.cancelButton} d-flex justify-content-center align-items-center`}
                      onClick={() => {
                        setErrors("");
                        setAssignTo("");
                        setReason("");
                        setRemoveUserModel(false);
                      }}
                    >
                      <button
                        type="button"
                        className={`btn`}
                        style={{ color: "#2348AB" }}
                      >
                        Close
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        )}
        <div className={`${styles.title} mt-5`}>User Management </div>
        <div
          className={`${styles.bulkPayoutButton} mt-5 d-flex justify-content-center align-items-center p-2 gap-2`}
          onClick={() => {
            setSelectedRowVal({});
            setShowModal(true);
          }}
        >
          <img
            className={`${styles.plusCircleIcon} pe-1`}
            alt=""
            src="/pluscircle.svg"
          />
          Add user
        </div>
      </div>
      <div className={`${styles.root} mt-2`}>
        <section className={styles.transactionDataTable}>
          <div className={styles.top}>
            <div className={styles.reportHeader}>
              <h3 className={styles.latestAccountTransaction}>User List</h3>
              <div className={styles.filter}>
                <div className={styles.textField}>
                  <div className={styles.content}>
                    <img
                      className={styles.leadingIcon}
                      alt=""
                      src="/leadingicon.svg"
                    />
                    <input
                      className={styles.filterLabel}
                      placeholder="Search..."
                      type="text"
                      value={searchText}
                      onChange={(e) =>
                        setSearchText(e.target.value.toLowerCase())
                      }
                    />
                  </div>
                </div>
                <div
                  className={styles.reLoadTable}
                  onClick={() => setReloadButton(true)}
                >
                  <img
                    className={styles.reloadIcon}
                    loading="lazy"
                    alt=""
                    src="/reload.svg"
                  />
                </div>
              </div>
            </div>
            <div className={styles.headerSeparator} />
          </div>

          <div className={styles.reportTable}>
            <div className={styles.tableHeader}>
              <div className={styles.cell}> NAME</div>
              <div className={styles.cell}> EMAIL ID</div>
              <div className={styles.cell}> PHONE NO</div>
              <div className={styles.cell}> MAKER LIMIT</div>
              <div className={styles.cell}> APPROVER LIMIT</div>
              <div className={styles.cell}> ROLE</div>
              <div className={styles.cell}> STATUS</div>
              <div className={styles.cell}> ACTION</div>
            </div>

            {paginatedReports.length === 0 ? (
              <div
                className={`d-flex justify-content-center align-items-center py-4`}
                style={{
                  textAlign: "center",
                  fontWeight: 500,
                  height: "30vh",
                }}
              >
                <div className=" w-100">No data available</div>
              </div>
            ) : (
              paginatedReports.map((report, index) => (
                <div className={styles.tableRow} key={index}>
                  <div className={styles.cell}>{report.userName}</div>
                  <div className={styles.cell}>{report.mailId}</div>
                  <div className={styles.cell}>{report.phNumber}</div>
                  <div className={styles.cell}>
                    {" "}
                    {report.auth[0].role.toString() === "Owner"
                      ? "----"
                      : report.makerLimit === ""
                      ? "----"
                      : report.makerLimit || report.makerLimitValue}
                  </div>
                  <div className={styles.cell}>
                    {report.auth[0].role.toString() === "Owner"
                      ? "----"
                      : report.approverLimit === ""
                      ? "----"
                      : report.approverLimit || report.approverLimitValue}
                  </div>
                  <div className={styles.cell}>
                    {report.auth[0].role.toString()}
                  </div>
                  <div className={styles.cell}>
                    <span
                      className={
                        report.status === "Active"
                          ? styles.statusActive
                          : report.status === "Pending"
                          ? styles.statusPending
                          : styles.statusRemoved
                      }
                    >
                      {report.status}
                    </span>
                  </div>
                  <div className={styles.cell}>
                    {/* {report.status === "Removed" && (
                    <span
                      onClick={() => {
                        setSelectedRowVal(report);
                        setShowModal(true);
                      }}
                    >
                      Edit &nbsp; /
                    </span>
                  )} */}
                    <span
                      // className={styles.actionButton}
                      onClick={() => {
                        setSelectedRowVal(report);
                        if (
                          report.status === "Removed" ||
                          report.status === "In-Active"
                        ) {
                          setReasonModel(true);
                        } else setShowModal(true);
                      }}
                      className={` ${styles.actionButton} ${
                        role.toString() === "Owner" &&
                        report.auth[0].role.map((data) => data).toString() ===
                          "Owner"
                          ? styles.disabledDiv
                          : role.toString() === "Admin" &&
                            (report.auth[0].role
                              .map((data) => data)
                              .toString() === "Admin" ||
                              report.auth[0].role
                                .map((data) => data)
                                .toString() === "Super Admin" ||
                              report.auth[0].role
                                .map((data) => data)
                                .toString() === "Owner")
                          ? styles.disabledDiv
                          : role.toString() === "Super Admin" &&
                            (report.auth[0].role
                              .map((data) => data)
                              .toString() === "Super Admin" ||
                              report.auth[0].role
                                .map((data) => data)
                                .toString() === "Owner")
                          ? styles.disabledDiv
                          : role.toString() === "Approver"
                          ? styles.disabledDiv
                          : role.toString() === "Approver"
                          ? styles.disabledDiv
                          : role.toString() === "Approver"
                          ? styles.disabledDiv
                          : role.toString() === "Maker"
                          ? styles.disabledDiv
                          : role.toString() === "Viewer"
                          ? styles.disabledDiv
                          : ""
                      }`}
                    >
                      {report.status === "Removed" ||
                      report.status === "In-Active"
                        ? "View Reason"
                        : "Edit"}
                    </span>
                    {report.status === "Removed" ||
                    report.status === "In-Active" ? (
                      <img src="./viewIcon.svg" />
                    ) : (
                      <>
                        <span style={{ color: "#3246A9", margin: "0 8px" }}>
                          /
                        </span>
                        <img
                          style={{ cursor: "pointer" }}
                          // onClick={() => {
                          //   deleteUserData(report);
                          //   setRemoveUserModel(true);
                          // }}
                          onClick={() => {
                            setSelectedRowVal(report); // Set user to delete
                            setRemoveUserModel(true); // Open the delete confirmation modal
                          }}
                          src="/delIcon.svg"
                          className={` ${styles.deleteIcon} ${
                            role.toString() === "Owner" &&
                            report.auth[0].role
                              .map((data) => data)
                              .toString() === "Owner"
                              ? styles.disabledDiv
                              : role.toString() === "Admin" &&
                                (report.auth[0].role
                                  .map((data) => data)
                                  .toString() === "Admin" ||
                                  report.auth[0].role
                                    .map((data) => data)
                                    .toString() === "Super Admin" ||
                                  report.auth[0].role
                                    .map((data) => data)
                                    .toString() === "Owner")
                              ? styles.disabledDiv
                              : role.toString() === "Super Admin" &&
                                (report.auth[0].role
                                  .map((data) => data)
                                  .toString() === "Super Admin" ||
                                  report.auth[0].role
                                    .map((data) => data)
                                    .toString() === "Owner")
                              ? styles.disabledDiv
                              : role.toString() === "Approver"
                              ? styles.disabledDiv
                              : role.toString() === "Approver"
                              ? styles.disabledDiv
                              : role.toString() === "Approver"
                              ? styles.disabledDiv
                              : role.toString() === "Maker"
                              ? styles.disabledDiv
                              : role.toString() === "Viewer"
                              ? styles.disabledDiv
                              : ""
                          }`}
                          alt="delete"
                        />
                      </>
                    )}
                  </div>
                </div>
              ))
            )}
          </div>
          <TablePagination
            component="div"
            count={users.length}
            page={currentPage}
            onPageChange={(event, newPage) => setCurrentPage(newPage)}
            rowsPerPage={itemsPerPage}
            onRowsPerPageChange={(event) => {
              setItemsPerPage(parseInt(event.target.value, 10));
              setCurrentPage(0);
            }}
            rowsPerPageOptions={[5, 8, 10, 20]}
            sx={{
              "& .MuiTablePagination-selectLabel": {
                marginTop: "14px",
              },
              "& .MuiTablePagination-displayedRows": {
                marginTop: "14px",
              },
            }}
          />
        </section>
      </div>
      {showModal && (
        <AddUserModal
          page={"view"}
          selectedRowVal={selectedRowVal}
          onClose={() => setShowModal(false)}
          setUserAdded={setUserAdded}
        />
      )}{" "}
    </>
  );
};

const ButtonWithIcon = ({ icon, text }) => (
  <div className={styles.filterLinesParent}>
    <img className={styles.filterLinesIcon} alt="" src={`/${icon}`} />
    <div className={styles.labelText}>{text}</div>
  </div>
);

export default UserMgmt;
